module.exports = __webpack_public_path__ + "static/media/image_under_18.51e5f9a8.png";